import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "link-dialog",
    templateUrl: "link.component.html",
    styleUrls: ["./link.component.scss"],
    standalone: false
})
export class LinkDialogComponent {
  message: string = "Are you sure?";
  confirmButtonText = "Yes";
  cancelButtonText = "Cancel";
  submessage = "";
  helpMessage = "";
  buttonText;
  singleButtonText: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<LinkDialogComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      this.submessage = data.submessage || this.submessage;
      if (data.buttonText) {
        this.buttonText = data.buttonText;
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      }
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
